import React from "react";

const Contact =()=>{
    return(
    <div className="contact">
        <div class="icons2" id="icons">
            <a href="https://twitter.com/cyborg_parth"  >
                <i class="fab fa-twitter fa-4x"></i>
            </a>
            <a href="https://www.facebook.com/parth.khandelwal.750"  >
                <i class="fab fa-facebook fa-4x"></i>
            </a>
            <a href="https://www.linkedin.com/in/parth-khandelwal-3051941a0/"  >
                <i class="fab fa-linkedin fa-4x"></i>
            </a>
            <a href="https://github.com/Parthkhandelwal0"  >
                <i class="fab fa-github fa-4x"></i>
            </a>
            <a href="https://www.instagram.com/_parthkhandelwal_/" >
                <i class="fab fa-instagram fa-4x"></i>
            </a>
        </div>
        </div>
    // </div>
    )
}

export default Contact;